import { Button, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const LINE_HEIGHT = 22;
const MAX_ROWS = 2;

export const FeedbackDataBlock = ({
  title,
  text,
}: {
  title: string;
  text: string;
}) => {
  const [isReadMore, setIsReadMore] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  const checkOverflow = () => {
    const el = textRef.current;
    if (el) {
      const maxHeight = LINE_HEIGHT * MAX_ROWS;
      setShowToggle(el.scrollHeight > maxHeight);
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);

  return (
    <Stack gap="8px" alignItems="flex-start">
      <Typography
        fontSize="15px"
        lineHeight="18px"
        fontWeight={600}
        color="custom.textDarkBlue"
      >
        {title}
      </Typography>

      <Typography
        ref={textRef}
        fontSize="14px"
        lineHeight={`${LINE_HEIGHT}px`}
        color="text.secondary"
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: isReadMore ? "none" : MAX_ROWS,
          WebkitBoxOrient: "vertical",
          overflow: isReadMore ? "visible" : "hidden",
          textOverflow: "ellipsis",
          overflowWrap: "break-word",
        }}
      >
        {text}
      </Typography>

      {showToggle && (
        <Button
          onClick={() => setIsReadMore(!isReadMore)}
          sx={{
            textDecoration: "underline",
            whiteSpace: "nowrap",
            background: "none",
            color: "#1C3C6C",
            padding: 0,
            minWidth: 0,
            height: "36px",
          }}
        >
          {isReadMore ? "Show Less" : "Show More"}
        </Button>
      )}
    </Stack>
  );
};
